// extracted by mini-css-extract-plugin
export default {"stake":"hP0fb","disabledIcon":"ZFrW8","betPrice":"zxaoo"};